/**
 * Complete Authentic Telugu Translations for MyMenuBuddy Recipes (All 48 Dishes)
 */

export const STATE_TELUGU_MAP = {
  "Tamil Nadu": "తమిళనాడు",
  "Tamil Nadu / South India": "తమిళనాడు / దక్షిణ భారతదేశం",
  "Kerala": "కేరళ",
  "Andhra Pradesh": "ఆంధ్రప్రదేశ్",
  "Karnataka": "కర్ణాటక",
  "Punjab": "పంజాబ్",
  "Maharashtra": "మహారాష్ట్ర",
  "Delhi / Punjab": "ఢిల్లీ / పంజాబ్",
  "North India": "ఉత్తర భారతదేశం",
  "Tamil Nadu / Kerala": "తమిళనాడు / కేరళ",
  "Indo-Chinese": "ఇండో-చైనీస్",
  "West Bengal": "పశ్చిమ బెంగాల్",
  "Punjab / Delhi": "పంజాబ్ / ఢిల్లీ",
  "India Healthy": "ఆరోగ్యకర సాంప్రదాయ ఆహారం",
  "Central Thailand": "థాయిలాండ్",
  "Kanto": "జపాన్",
  "Beirut Governorate": "లెబనాన్ / మధ్యప్రాచ్యం",
  "Central Mexico": "మెక్సికో",
  "Campania": "ఇటలీ",
  "Lazio": "ఇటలీ",
  "Global": "అంతర్జాతీయ",
  "Tamil Nadu / Telangana": "తమిళనాడు / తెలంగాణ",
  "Kerala / Tamil Nadu": "కేరళ / తమిళనాడు"
};

export const CUISINE_TELUGU_MAP = {
  "Tamil Nadu Breakfast": "తమిళనాడు అల్పాహారం",
  "Tamil Nadu Traditional": "తమిళ సాంప్రదాయం",
  "Temple Style Breakfast": "దేవాలయ శైలి టిఫిన్",
  "South Indian Breakfast": "దక్షిణ భారత అల్పాహారం",
  "Kerala Syrian Christian": "కేరళ సాంప్రదాయం",
  "Andhra Breakfast": "ఆంధ్ర అల్పాహారం",
  "Karnataka Tiffin": "కర్ణాటక టిఫిన్",
  "Punjabi Breakfast": "పంజాబీ అల్పాహారం",
  "Maharashtrian Breakfast": "మహారాష్ట్ర అల్పాహారం",
  "Tamil Nadu Comfort Food": "తమిళనాడు స్పెషల్ భోజనం",
  "Kongunadu": "కొంగునాడు వంటకాలు",
  "Tirunelveli Traditional": "తిరునెల్వేలి సాంప్రదాయం",
  "Chettinad Non-Veg": "చెట్టినాడు నాన్-వెజ్",
  "Royal Biryani": "షాహీ దమ్ బిర్యానీ",
  "Coastal Seafood": "తీరప్రాంత సీఫుడ్",
  "North Indian Dhaba": "ఉత్తర భారత ధాబా శైలి",
  "Punjabi Comfort Food": "పంజాబీ సాంప్రదాయం",
  "Andhra Spicy": "ఆంధ్ర ఘాటైన వంటకాలు",
  "North Indian Homestyle": "ఉత్తర భారత ఇంటి వంట",
  "Mughlai North Indian": "మొఘలాయి నార్త్ ఇండియన్",
  "Street Tiffin Classic": "స్ట్రీట్ టిఫిన్ స్పెషల్",
  "Italian Classic": "ఇటాలియన్ క్లాసిక్",
  "Italian Pasta": "ఇటాలియన్ పాస్తా",
  "Indo-Chinese": "ఇండో-చైనీస్",
  "Indo-Chinese Non-Veg": "ఇండో-చైనీస్ నాన్-వెజ్",
  "Thai Street Food": "థాయ్ స్ట్రీట్ ఫుడ్",
  "Japanese Ramen": "జపనీస్ రామెన్",
  "Middle Eastern": "మధ్యప్రాచ్య వంటకాలు",
  "Mumbai Street Food": "ముంబై స్ట్రీట్ ఫుడ్",
  "Punjabi Street Food": "పంజాబీ స్ట్రీట్ ఫుడ్",
  "Mexican Traditional": "మెక్సికన్ సాంప్రదాయం",
  "Evening Tea Snack": "సాయంత్రం టీ స్నాక్స్",
  "Kanyakumari Coastal": "కన్యాకుమారి సీఫుడ్",
  "Kerala Seafood Classic": "కేరళ సీఫుడ్ క్లాసిక్",
  "Kerala Non-Veg Breakfast": "కేరళ నాన్-వెజ్ బ్రేక్‌ఫాస్ట్",
  "Kerala Traditional": "కేరళ సాంప్రదాయం",
  "Sadhya Classic": "కేరళ సద్యా విందు",
  "High Protein Dinner": "హై ప్రోటీన్ డిన్నర్",
  "Temple Snack & Tea Time": "ఆలయ ప్రసాదం & స్నాక్స్",
  "Military Mess Classic": "మిలిటరీ మెస్ స్పెషల్",
  "Wholesome Millet Classic": "చిరుధాన్యాల ఆరోగ్య భోజనం",
  "Fiber Rich Breakfast": "పీచు పదార్థాలు నిండిన అల్పాహారం",
  "Madurai Street Food": "మధురై స్ట్రీట్ స్పెషల్"
};

export const TELUGU_RECIPES = {
  "1": {
    "meal_te": "మల్లెపూవు లాంటి మెత్తని ఇడ్లీ + సాంబార్ + కొబ్బరి చట్నీ",
    "desc_te": "దూది లాంటి మెత్తని ఇడ్లీలతో పాటు రుచికరమైన కాయగూరల సాంబార్ మరియు తాజా కొబ్బరి చట్నీ.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తమిళనాడు అల్పాహారం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మెత్తని స్టీమ్డ్ ఇడ్లీ",
        "ingredients_te": [
          [
            "ఇడ్లీ బియ్యం",
            "2 cups"
          ],
          [
            "మినప్పప్పు",
            "1/2 cup"
          ],
          [
            "మెంతులు",
            "1 tsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ],
          [
            "నీరు",
            "as needed"
          ]
        ],
        "quick_te": "బియ్యం, మినప్పప్పు 4 గంటలు నానబెట్టి రుబ్బండి|8 గంటలు పులియబెట్టండి|ఆవిరిపై 10 నిమిషాలు ఉడికించండి"
      },
      {
        "name_te": "కాయగూరల సాంబార్",
        "ingredients_te": [
          [
            "కందిపప్పు",
            "1/2 cup"
          ],
          [
            "ఉల్లిపాయ",
            "1.5 cups"
          ],
          [
            "టమోటా",
            "1 chopped"
          ],
          [
            "చింతపండు రసం",
            "2 tbsp"
          ],
          [
            "సాంబార్ పొడి",
            "1.5 tbsp"
          ],
          [
            "పసుపు",
            "1/4 tsp each"
          ],
          [
            "ఆవాలు",
            "for tempering"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "పప్పును ఉడికించండి|కాయగూరలను చింతపండు రసం, సాంబార్ పొడితో ఉడికించండి|పోపు వేసి కలపండి"
      },
      {
        "name_te": "తాజా కొబ్బరి చట్నీ",
        "ingredients_te": [
          [
            "తురిమిన కొబ్బరి",
            "1 cup"
          ],
          [
            "పుట్నాల పప్పు",
            "2 tbsp"
          ],
          [
            "పచ్చిమిర్చి",
            "2 pcs"
          ],
          [
            "అల్లం",
            "1/2 inch"
          ],
          [
            "ఆవాలు",
            "for tadka"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "కొబ్బరి, పుట్నాలు, మిర్చి, అల్లం వేసి రుబ్బండి|ఆవాలు, కరివేపాకు పోపు పెట్టండి"
      }
    ]
  },
  "2": {
    "meal_te": "కరకరలాడే నేతి దోశ + సాంబార్ + టమోటా చట్నీ",
    "desc_te": "బంగారు వర్ణంలో కరకరలాడే నేతి దోశ, ఘుమఘుమలాడే సాంబార్ మరియు కారంగా ఉండే టమోటా ఉల్లి చట్నీ.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తమిళ సాంప్రదాయం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "కరకరలాడే నేతి దోశ",
        "ingredients_te": [
          [
            "బియ్యం",
            "2 cups"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "నీరు",
            "to adjust consistency"
          ]
        ],
        "quick_te": "వేడి పెనంపై పిండిని గుండ్రంగా తిప్పండి|నెయ్యి వేసి కాల్చండి|బంగారు రంగు రాగానే మడవండి"
      },
      {
        "name_te": "కారపు టమోటా చట్నీ",
        "ingredients_te": [
          [
            "టమోటా",
            "2 chopped"
          ],
          [
            "ఉల్లిపాయ",
            "1 chopped"
          ],
          [
            "వెల్లుల్లి",
            "4 cloves"
          ],
          [
            "ఎండుమిర్చి",
            "4 pcs"
          ],
          [
            "ఆవాలు",
            "for tadka"
          ],
          [
            "నువ్వుల నూనె",
            "1.5 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "ఉల్లి, టమోటాలు, ఎండుమిర్చి నూనెలో వేయించండి|గ్రైండ్ చేసి పోపు పెట్టండి"
      }
    ]
  },
  "3": {
    "meal_te": "నెయ్యి వెన్ పొంగల్ + మేదు వడ + సాంబార్",
    "desc_te": "మిరియాలు, జీలకర్ర, జీడిపప్పు, స్వచ్ఛమైన నెయ్యి సువాసనతో నిండిన వెన్ పొంగల్ మరియు కరకరలాడే మేదు వడ.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "దేవాలయ శైలి టిఫిన్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "నెయ్యి వెన్ పొంగల్",
        "ingredients_te": [
          [
            "పచ్చి బియ్యం",
            "1 cup"
          ],
          [
            "పెసరపప్పు",
            "1/2 cup roasted"
          ],
          [
            "స్వచ్ఛమైన నెయ్యి",
            "4 tbsp"
          ],
          [
            "మిరియాలు",
            "1 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tbsp"
          ],
          [
            "అల్లం",
            "1 tbsp finely minced"
          ],
          [
            "జీడిపప్పు",
            "12 pcs"
          ],
          [
            "ఇంగువ",
            "handful & 1/4 tsp"
          ],
          [
            "నీరు",
            "4.5 cups"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "బియ్యం, పెసరపప్పు మెత్తగా ఉడికించండి|నెయ్యిలో జీడిపప్పు, మిరియాలు, జీలకర్ర వేయించండి|పోపును కలపండి"
      },
      {
        "name_te": "కరకరలాడే మేదు వడ",
        "ingredients_te": [
          [
            "మినప్పప్పు",
            "1 cup"
          ],
          [
            "అల్లం",
            "1 tsp each minced"
          ],
          [
            "మిరియాలు",
            "1 tsp"
          ],
          [
            "ఇంగువ",
            "1 sprig & pinch"
          ],
          [
            "నూనె",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "మినప్పప్పును గట్టిగా రుబ్బండి|మిరియాలు, కరివేపాకు కలపండి|మధ్యలో రంధ్రం చేసి నూనెలో వేయించండి"
      }
    ]
  },
  "4": {
    "meal_te": "బంగారు పూరీ + ఆలూ మసాలా (పూరీ కూర)",
    "desc_te": "వేడివేడిగా పొంగే గోధుమ పూరీలు మరియు హోటల్ శైలి రుచికరమైన ఆలూ మసాలా కూర.",
    "state_te": "తమిళనాడు / దక్షిణ భారతదేశం",
    "cuisine_te": "దక్షిణ భారత అల్పాహారం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "బంగారు వేడి పూరీలు",
        "ingredients_te": [
          [
            "గోధుమ పిండి",
            "2 cups"
          ],
          [
            "బొంబాయి రవ్వ",
            "1 tbsp for crispiness"
          ],
          [
            "నీరు",
            "3/4 cup"
          ],
          [
            "నూనె",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "గోధుమ పిండి కలపండి|చిన్న పూరీలుగా ఒత్తండి|వేడి నూనెలో పొంగేలా వేయించండి"
      },
      {
        "name_te": "హోటల్ శైలి ఆలూ మసాలా",
        "ingredients_te": [
          [
            "నూనె",
            "3 large"
          ],
          [
            "ఉల్లిపాయలు",
            "2 sliced"
          ],
          [
            "పచ్చిమిర్చి",
            "3 slit"
          ],
          [
            "అల్లం",
            "1 tbsp minced"
          ],
          [
            "Besan (Gram Flour)",
            "1 tbsp dissolved in 1/4 cup water"
          ],
          [
            "పసుపు",
            "1/2 tsp"
          ],
          [
            "మినప్పప్పు",
            "1/2 tsp each"
          ],
          [
            "కరివేపాకు",
            "handful"
          ],
          [
            "నూనె",
            "1.5 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "నూనెలో పోపు, ఉల్లి, పచ్చిమిర్చి వేయించండి|ఉడికించిన ఆలూ, పసుపు కలపండి|శనగపిండి నీరు పోసి చిక్కబడేవరకు ఉడికించండి"
      }
    ]
  },
  "5": {
    "meal_te": "ఆప్పం + వెజ్ కొబ్బరిపాలు స్టూ (కేరళ పాలప్పం)",
    "desc_te": "మధ్యలో మెత్తగా, అంచులలో లేస్ లాంటి పాలప్పం మరియు సుగంధ ద్రవ్యాలతో కూడిన కొబ్బరిపాలు కాయగూరల స్టూ.",
    "state_te": "కేరళ",
    "cuisine_te": "కేరళ సాంప్రదాయం",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "లేస్ అంచుల పాలప్పం",
        "ingredients_te": [
          [
            "పచ్చి బియ్యం",
            "2 cups soaked"
          ],
          [
            "తురిమిన కొబ్బరి",
            "1 cup"
          ],
          [
            "వండిన అన్నం",
            "1/2 cup"
          ],
          [
            "Yeast",
            "1/2 tsp"
          ],
          [
            "ఉప్పు",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_te": "బియ్యం, కొబ్బరి, అన్నం రుబ్బి పులియబెట్టండి|ఆప్పం పెనంలో పిండిని తిప్పండి|మూతపెట్టి ఆవిరిపై ఉడికించండి"
      },
      {
        "name_te": "కాయగూరల కొబ్బరిపాలు స్టూ",
        "ingredients_te": [
          [
            "బంగాళాదుంప",
            "2 cups"
          ],
          [
            "పాలు",
            "1 cup & 2 cups"
          ],
          [
            "ఉల్లిపాయ",
            "1 sliced, 1 tbsp minced, 3 slit"
          ],
          [
            "యాలకులు",
            "few"
          ],
          [
            "కొబ్బరి నూనె",
            "2 tbsp"
          ],
          [
            "మిరియాలు",
            "handful & 1/2 tsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "మసాలాలు, అల్లం, ఉల్లి వేయించండి|కూరగాయలను పల్చటి పాలలో ఉడికించండి|చిక్కటి కొబ్బరిపాలు పోసి దించండి"
      }
    ]
  },
  "6": {
    "meal_te": "ఆంధ్ర పెసరట్టు + అల్లం చట్నీ (ఉప్మా పెసరట్టు)",
    "desc_te": "ఆంధ్ర స్పెషల్ కరకరలాడే పెసరట్టు, ఘాటైన అల్లం చట్నీ మరియు వేడి ఉప్మా కాంబినేషన్.",
    "state_te": "ఆంధ్రప్రదేశ్",
    "cuisine_te": "ఆంధ్ర అల్పాహారం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "ఆంధ్ర పెసరట్టు",
        "ingredients_te": [
          [
            "పెసరపప్పు",
            "2 cups"
          ],
          [
            "బియ్యం",
            "2 tbsp"
          ],
          [
            "అల్లం",
            "3 pcs & 1 inch"
          ],
          [
            "ఉల్లిపాయ",
            "1/2 cup & 1 tsp for topping"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "పెసలు, అల్లం, మిర్చి కలిపి రుబ్బండి|పెనంపై పల్చగా తిప్పండి|ఉల్లిపాయలు, జీలకర్ర చల్లి కాల్చండి"
      },
      {
        "name_te": "ఘాటైన అల్లం చట్నీ",
        "ingredients_te": [
          [
            "అల్లం",
            "1/2 cup"
          ],
          [
            "చింతపండు రసం",
            "3 tbsp"
          ],
          [
            "బెల్లం",
            "3 tbsp"
          ],
          [
            "ఎండుమిర్చి",
            "4 pcs"
          ],
          [
            "మినప్పప్పు",
            "1 tbsp each"
          ],
          [
            "నూనె",
            "for tadka"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "అల్లం, చింతపండు, బెల్లం, ఎండుమిర్చి వేయించి రుబ్బండి|ఆవాలు, కరివేపాకు పోపు పెట్టండి"
      }
    ]
  },
  "7": {
    "meal_te": "రవ్వ ఉప్మా + కొబ్బరి చట్నీ",
    "desc_te": "తాజా కూరగాయలు, నెయ్యి మరియు జీడిపప్పుతో తయారైన ఘుమఘుమలాడే రవ్వ ఉప్మా మరియు కొబ్బరి చట్నీ.",
    "state_te": "కర్ణాటక",
    "cuisine_te": "కర్ణాటక టిఫిన్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "కాయగూరల రవ్వ ఉప్మా",
        "ingredients_te": [
          [
            "రవ్వ",
            "1 cup"
          ],
          [
            "నీరు",
            "2.5 cups"
          ],
          [
            "ఉల్లిపాయ",
            "1 cup chopped"
          ],
          [
            "అల్లం",
            "1 tsp each minced"
          ],
          [
            "ఆవాలు",
            "10 pcs & 1 tsp"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "కరివేపాకు",
            "handful"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "రవ్వను నేతిలో వేయించండి|పోపు, కూరగాయలు ఉడికించి నీరు మరిగించండి|రవ్వ వేసి ఉండలు లేకుండా కలపండి"
      }
    ]
  },
  "8": {
    "meal_te": "పంజాబీ ఆలూ పరాఠా + గడ్డ పెరుగు + తాజా వెన్న",
    "desc_te": "మసాలా బంగాళాదుంప మిశ్రమంతో నిండిన వేడి పరాఠా, చల్లని గడ్డ పెరుగు మరియు తాజా వెన్న ముద్ద.",
    "state_te": "పంజాబ్",
    "cuisine_te": "పంజాబీ అల్పాహారం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మసాలా ఆలూ పరాఠా",
        "ingredients_te": [
          [
            "గోధుమ పిండి",
            "2 cups"
          ],
          [
            "నూనె",
            "3 large"
          ],
          [
            "అల్లం",
            "finely chopped"
          ],
          [
            "గరం మసాలా",
            "1/2 tsp each"
          ],
          [
            "నెయ్యి",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "ఉడికించిన ఆలూలో మసాలాలు కలపండి|గోధుమ పిండిలో కూర్చి ఒత్తండి|నెయ్యితో రెండు వైపులా కాల్చండి"
      },
      {
        "name_te": "గడ్డ పెరుగు & వెన్న",
        "ingredients_te": [
          [
            "పెరుగు",
            "1 cup"
          ],
          [
            "వెన్న",
            "1 generous dollop"
          ],
          [
            "ఉప్పు",
            "pinch for dusting"
          ]
        ],
        "quick_te": "చల్లని గడ్డ పెరుగు మరియు తాజా వెన్న ముద్దతో సర్వ్ చేయండి"
      }
    ]
  },
  "9": {
    "meal_te": "మహారాష్ట్రీయన్ కందా పోహా + సేవ్‌ + నిమ్మకాయ",
    "desc_te": "ఉల్లిపాయలు, పల్లీలు, పసుపు, కరివేపాకుతో తయారైన తేలికైన పోహా మరియు కరకరలాడే సేవ్‌.",
    "state_te": "మహారాష్ట్ర",
    "cuisine_te": "మహారాష్ట్ర అల్పాహారం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మహారాష్ట్రీయన్ కందా పోహా",
        "ingredients_te": [
          [
            "బియ్యం",
            "2 cups rinsed and drained"
          ],
          [
            "ఉల్లిపాయ",
            "1.5 cups chopped"
          ],
          [
            "బంగాళాదుంప",
            "1 boiled/fried"
          ],
          [
            "పల్లీలు",
            "3 tbsp"
          ],
          [
            "జీలకర్ర",
            "1/2 tsp each"
          ],
          [
            "పచ్చిమిర్చి",
            "3 slit & 1 sprig"
          ],
          [
            "పసుపు",
            "1/2 tsp & 1/2 tsp"
          ],
          [
            "నిమ్మకాయ",
            "for garnish"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "పోహాను కడిగి నానబెట్టండి|నూనెలో ఆవాలు, పల్లీలు, ఉల్లి, ఆలూ వేయించండి|పోహా, పసుపు, నిమ్మరసం కలిపి సర్వ్ చేయండి"
      }
    ]
  },
  "10": {
    "meal_te": "సాంబార్ అన్నం + బంగాళాదుంప వేపుడు + అప్పడం",
    "desc_te": "పప్పు, కూరగాయలు, నెయ్యితో కుండలో వండిన వేడి సాంబార్ అన్నం, కారపు ఆలూ రోస్ట్ మరియు అప్పడం.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తమిళనాడు స్పెషల్ భోజనం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "సాంబార్ అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1 cup"
          ],
          [
            "కందిపప్పు",
            "1/2 cup"
          ],
          [
            "Mixed Vegetables",
            "1.5 cups"
          ],
          [
            "చింతపండు రసం",
            "3 tbsp"
          ],
          [
            "సాంబార్ పొడి",
            "2 tbsp"
          ],
          [
            "పసుపు",
            "1/4 tsp each"
          ],
          [
            "స్వచ్ఛమైన నెయ్యి",
            "3 tbsp"
          ],
          [
            "ఆవాలు",
            "for tadka"
          ],
          [
            "నీరు",
            "4.5 cups"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "బియ్యం, పప్పు, కూరగాయలు కుక్కర్‌లో ఉడికించండి|సాంబార్ పొడి, చింతపండు రసం, నెయ్యి కలపండి|పోపు వేయండి"
      },
      {
        "name_te": "కారపు ఆలూ రోస్ట్",
        "ingredients_te": [
          [
            "బంగాళాదుంప",
            "2 large"
          ],
          [
            "సాంబార్ పొడి",
            "1 tsp each"
          ],
          [
            "కరివేపాకు",
            "1/2 tsp & 1 sprig"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "బంగాళాదుంప ముక్కలకు కారం, పసుపు, ఉప్పు పట్టించండి|బాండీలో నూనె వేసి దోరగా వేయించండి"
      },
      {
        "name_te": "కరకరలాడే అప్పడం",
        "ingredients_te": [
          [
            "మినప్పప్పు",
            "4 pcs"
          ],
          [
            "నూనె",
            "1 cup"
          ]
        ],
        "quick_te": "వేడి నూనెలో అప్పడాలను వేయించి తీయండి"
      }
    ]
  },
  "11": {
    "meal_te": "మిరియాల రసం అన్నం + ఆలూ ఫ్రై + అప్పడం",
    "desc_te": "జీలకర్ర, మిరియాలు, వెల్లుల్లి ఘాటుతో కూడిన రసం, వేడి అన్నం మరియు కరకరలాడే బంగాళాదుంప వేపుడు.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తమిళనాడు స్పెషల్ భోజనం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మిరియాల టమోటా రసం",
        "ingredients_te": [
          [
            "టమోటా",
            "2 mashed"
          ],
          [
            "చింతపండు రసం",
            "2 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tbsp each crushed"
          ],
          [
            "వెల్లుల్లి",
            "6 cloves crushed"
          ],
          [
            "పసుపు",
            "1/4 tsp each"
          ],
          [
            "ఆవాలు",
            "for tadka"
          ],
          [
            "నెయ్యి",
            "1 tbsp"
          ],
          [
            "నీరు",
            "2.5 cups"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "టమోటాలు, చింతపండు నీటిలో ఉడికించండి|మిరియాలు, జీలకర్ర, వెల్లుల్లి దంచి కలపండి|మరగనిచ్చి పోపు వేయండి"
      },
      {
        "name_te": "ఆలూ ఫ్రై",
        "ingredients_te": [
          [
            "బంగాళాదుంపలు",
            "2 sliced"
          ],
          [
            "Chilli Powder",
            "1 tsp"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "ఆలూ ముక్కలను నూనెలో కారంతో దోరగా వేయించండి"
      },
      {
        "name_te": "వేడి అన్నం & అప్పడం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "అప్పడం",
            "4 pcs"
          ],
          [
            "నీరు",
            "for cooking & frying"
          ]
        ],
        "quick_te": "వేడి బాస్మతి లేదా సోనా మసూరి అన్నం"
      }
    ]
  },
  "12": {
    "meal_te": "పెరుగు అన్నం (దద్దోజనం) + ఆలూ ఫ్రై + ఊరగాయ",
    "desc_te": "దక్షిణ భారత దేవాలయ శైలి చల్లని పెరుగు అన్నం, కారపు ఆలూ ఫ్రై మరియు నిమ్మకాయ ఊరగాయ.",
    "state_te": "తమిళనాడు / దక్షిణ భారతదేశం",
    "cuisine_te": "తమిళనాడు స్పెషల్ భోజనం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "దేవాలయ శైలి దద్దోజనం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "పెరుగు",
            "1 cup"
          ],
          [
            "పాలు",
            "1/2 cup"
          ],
          [
            "వెన్న",
            "1 tbsp"
          ],
          [
            "అల్లం",
            "1 tsp each minced"
          ],
          [
            "మినప్పప్పు",
            "1/2 tsp each"
          ],
          [
            "ఇంగువ",
            "1 pinch"
          ],
          [
            "కరివేపాకు",
            "handful"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "అన్నాన్ని మెత్తగా మెదపండి|పెరుగు, పాలు, ఉప్పు కలపండి|ఆవాలు, మిర్చి, అల్లం, కరివేపాకు పోపు పెట్టండి"
      },
      {
        "name_te": "ఆలూ ఫ్రై",
        "ingredients_te": [
          [
            "బంగాళాదుంపలు",
            "2 sliced"
          ],
          [
            "సాంబార్ పొడి",
            "1 tsp each"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "ఆలూ ముక్కలను నూనెలో కారంతో దోరగా వేయించండి"
      }
    ]
  },
  "13": {
    "meal_te": "కొంగు అరిసి పరుప్పు అన్నం + ఆలూ ఫ్రై",
    "desc_te": "తమిళనాడు కొంగునాడు సాంప్రదాయ పప్పు అన్నం, స్వచ్ఛమైన నెయ్యి మరియు ఆలూ వేపుడు.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "కొంగునాడు వంటకాలు",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "కొంగు అరిసి పరుప్పు అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1 cup"
          ],
          [
            "కందిపప్పు",
            "1/3 cup"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "12 sliced"
          ],
          [
            "వెల్లుల్లి",
            "6 cloves"
          ],
          [
            "టమోటా",
            "1 chopped"
          ],
          [
            "సాంబార్ పొడి",
            "1 tsp"
          ],
          [
            "నెయ్యి",
            "2 tbsp"
          ],
          [
            "జీలకర్ర",
            "for tadka"
          ],
          [
            "నీరు",
            "3 cups"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "కుక్కర్‌లో పోపు, ఉల్లి, టమోటా వేయించండి|బియ్యం, పప్పు, సాంబార్ పొడి కలపండి|ఉడికించి నెయ్యి వేయండి"
      },
      {
        "name_te": "ఆలూ ఫ్రై",
        "ingredients_te": [
          [
            "బంగాళాదుంపలు",
            "2 cubed"
          ],
          [
            "Chilli Powder",
            "1 tsp"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "ఆలూ ముక్కలను నూనెలో కారంతో దోరగా వేయించండి"
      }
    ]
  },
  "14": {
    "meal_te": "తిరునెల్వేలి సోధి (కొబ్బరిపాలు కుజ్హంబు) + అన్నం + ఆలూ రోస్ట్",
    "desc_te": "తిరునెల్వేలి స్పెషల్ ఘుమఘుమలాడే కొబ్బరిపాలు కూర, వేడి అన్నం మరియు ఇజ్జిపులి పచ్చడి.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తిరునెల్వేలి సాంప్రదాయం",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "తిరునెల్వేలి సోధి కూర",
        "ingredients_te": [
          [
            "పెసరపప్పు",
            "1/2 cup"
          ],
          [
            "పాలు",
            "1 cup & 2 cups"
          ],
          [
            "బంగాళాదుంప",
            "1.5 cups"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "10 sliced & 4 slit"
          ],
          [
            "అల్లం",
            "1 tbsp & 1.5 tbsp"
          ],
          [
            "కొబ్బరి నూనె",
            "2 tbsp"
          ],
          [
            "ఆవాలు",
            "for tadka"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "కూరగాయలను పల్చటి కొబ్బరిపాలలో ఉడికించండి|పప్పు పేస్ట్, చిక్కటి కొబ్బరిపాలు కలపండి|నిమ్మరసం పిండండి"
      },
      {
        "name_te": "నెల్లై ఇంజి పులి పచ్చడి",
        "ingredients_te": [
          [
            "అల్లం",
            "1/2 cup"
          ],
          [
            "చింతపండు",
            "1/2 cup"
          ],
          [
            "బెల్లం",
            "2 tbsp"
          ],
          [
            "పసుపు",
            "1 tsp & 1/4 tsp"
          ],
          [
            "నూనె",
            "for tadka"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "అల్లం ముక్కలను నూనెలో వేయించండి|చింతపండు గుజ్జు, బెల్లం, కారంతో ఉడికించండి"
      },
      {
        "name_te": "ఆలూ రోస్ట్ & అన్నం",
        "ingredients_te": [
          [
            "బంగాళాదుంపలు",
            "2 cubed"
          ],
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "నూనె",
            "for cooking"
          ]
        ],
        "quick_te": "మసాలా ఆలూ రోస్ట్ మరియు వేడి అన్నం"
      }
    ]
  },
  "15": {
    "meal_te": "చెట్టినాడ్ పెప్పర్ చికెన్ + రసం అన్నం + ఆలూ రోస్ట్",
    "desc_te": "తాజా నల్లమిరియాల ఘాటుతో కూడిన చెట్టినాడ్ చికెన్ చుక్కా, పూండు మిరియాల రసం మరియు అన్నం.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "చెట్టినాడు నాన్-వెజ్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "చెట్టినాడ్ పెప్పర్ చికెన్",
        "ingredients_te": [
          [
            "చికెన్",
            "500g"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "15 sliced"
          ],
          [
            "మిరియాలు",
            "1.5 tbsp"
          ],
          [
            "Coriander Seeds",
            "1 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tsp each"
          ],
          [
            "ఎండుమిర్చి",
            "4 pcs"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1 tbsp"
          ],
          [
            "నువ్వుల నూనె",
            "3 tbsp"
          ],
          [
            "కరివేపాకు",
            "3 sprigs"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "చికెన్‌ను మసాలాలతో ఉడికించండి|బాండీలో మిరియాల పొడి, ఉల్లిపాయలతో నూనెలో డ్రైగా రోస్ట్ చేయండి"
      },
      {
        "name_te": "పూండు మిరియాల రసం",
        "ingredients_te": [
          [
            "వెల్లుల్లి",
            "8 cloves"
          ],
          [
            "జీలకర్ర",
            "1 tbsp each crushed"
          ],
          [
            "టమోటా",
            "1 mashed"
          ],
          [
            "నీరు",
            "1.5 cups"
          ],
          [
            "పసుపు",
            "1/4 tsp each"
          ],
          [
            "నెయ్యి",
            "1 tsp"
          ],
          [
            "ఆవాలు",
            "for tadka"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "వెల్లుల్లి, మిరియాలు, జీలకర్ర దంచి చింతపండు నీటిలో మరిగించండి"
      },
      {
        "name_te": "కారపు ఆలూ రోస్ట్",
        "ingredients_te": [
          [
            "బంగాళాదుంపలు",
            "2 cubed"
          ],
          [
            "సాంబార్ పొడి",
            "1 tsp each"
          ],
          [
            "కరివేపాకు",
            "1/2 tsp & 1 sprig"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "కారంతో వేయించిన బంగాళాదుంప ముక్కలు"
      },
      {
        "name_te": "వేడి అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "నీరు",
            "3.5 cups"
          ]
        ],
        "quick_te": "ఆవిరిపై వండిన అన్నం"
      }
    ]
  },
  "16": {
    "meal_te": "షాహీ దమ్ చికెన్ బిర్యానీ + ఉల్లిపాయ రైతా + వంకాయ గ్రేవీ",
    "desc_te": "బాస్మతి బియ్యం, సుగంధ ద్రవ్యాలతో దమ్ పద్ధతిలో వండిన చికెన్ బిర్యానీ, మిర్చి కా సాలన్ మరియు రైతా.",
    "state_te": "తమిళనాడు / తెలంగాణ",
    "cuisine_te": "షాహీ దమ్ బిర్యానీ",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "షాహీ దమ్ చికెన్ బిర్యానీ",
        "ingredients_te": [
          [
            "బియ్యం",
            "2 cups"
          ],
          [
            "చికెన్",
            "600g"
          ],
          [
            "ఉల్లిపాయ",
            "3 large"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "2 tbsp"
          ],
          [
            "పచ్చిమిర్చి",
            "5 pcs"
          ],
          [
            "పెరుగు",
            "1/2 cup"
          ],
          [
            "గరం మసాలా",
            "1.5 tsp"
          ],
          [
            "పసుపు",
            "1.5 tsp & 1/2 tsp"
          ],
          [
            "Mint & Coriander",
            "1 cup chopped"
          ],
          [
            "నూనె",
            "3 tbsp each"
          ],
          [
            "ఉప్పు",
            "2 tsp"
          ]
        ],
        "quick_te": "చికెన్‌ను పెరుగు, మసాలాలతో మారినేట్ చేయండి|బాస్మతి బియ్యం పొరలుగా వేయండి|దమ్ పద్ధతిలో 25 నిమిషాలు ఉడికించండి"
      },
      {
        "name_te": "బిర్యానీ వంకాయ గ్రేవీ",
        "ingredients_te": [
          [
            "వంకాయ",
            "4 slit"
          ],
          [
            "పల్లీలు",
            "2 tbsp each roasted & ground"
          ],
          [
            "చింతపండు రసం",
            "2 tbsp"
          ],
          [
            "ఉల్లిపాయ",
            "1 chopped"
          ],
          [
            "సాంబార్ పొడి",
            "1.5 tsp"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "వంకాయలను నూనెలో వేయించండి|నువ్వులు, పల్లీలు, చింతపండు మసాలా గ్రేవీలో ఉడికించండి"
      },
      {
        "name_te": "చల్లని ఉల్లిపాయ రైతా",
        "ingredients_te": [
          [
            "పెరుగు",
            "1 cup"
          ],
          [
            "ఉల్లిపాయ",
            "1 finely sliced"
          ],
          [
            "Green Chilli & Coriander",
            "1 tsp each"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "ఉల్లిపాయలు, పచ్చిమిర్చి, కొత్తిమీర పెరుగులో కలపండి"
      }
    ]
  },
  "17": {
    "meal_te": "చేపల పులుసు (మీన్ కుజ్హంబు) + వేడి అన్నం + చేపల వేపుడు",
    "desc_te": "సాంప్రదాయ గ్రామ శైలి మట్టి కుండ చేపల పులుసు, వేడి అన్నం మరియు మసాలా చేపల ఫ్రై.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తీరప్రాంత సీఫుడ్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "మద్రాస్ చేపల పులుసు",
        "ingredients_te": [
          [
            "చేపలు",
            "500g"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "15 peeled"
          ],
          [
            "వెల్లుల్లి",
            "10 cloves"
          ],
          [
            "టమోటాలు",
            "2 pureed"
          ],
          [
            "చింతపండు రసం",
            "4 tbsp"
          ],
          [
            "సాంబార్ పొడి",
            "2.5 tbsp"
          ],
          [
            "మెంతులు",
            "1/4 tsp & 1/2 tsp"
          ],
          [
            "ఆవాలు",
            "for tempering"
          ],
          [
            "నువ్వుల నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "మట్టికుండలో పోపు, చిన్న ఉల్లిపాయలు, టమోటాలు వేయించండి|చింతపండు పులుసు మరిగించండి|చేప ముక్కలు వేసి 7 నిమిషాలు ఉడికించండి"
      },
      {
        "name_te": "మసాలా చేపల ఫ్రై",
        "ingredients_te": [
          [
            "చేపలు",
            "300g"
          ],
          [
            "Chilli Powder",
            "1.5 tsp"
          ],
          [
            "పసుపు",
            "1/2 tsp each"
          ],
          [
            "అల్లం",
            "1 tbsp & 1 tsp"
          ],
          [
            "బియ్యం",
            "1 tbsp"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "చేప ముక్కలకు మసాలాలు పట్టించండి|తవాపై నూనె వేసి రెండు వైపులా వేయించండి"
      },
      {
        "name_te": "వేడి అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "నీరు",
            "3.5 cups"
          ]
        ],
        "quick_te": "ఆవిరిపై వండిన అన్నం"
      }
    ]
  },
  "18": {
    "meal_te": "డబుల్ తడ్కా దాల్ + జీరా రైస్ + ఆలూ గోబీ",
    "desc_te": "సుగంధ ద్రవ్యాల తాళింపుతో కూడిన పసుపు పప్పు, జీలకర్ర బాస్మతి అన్నం మరియు ఆలూ గోబీ డ్రై సబ్జీ.",
    "state_te": "ఢిల్లీ / పంజాబ్",
    "cuisine_te": "ఉత్తర భారత ధాబా శైలి",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "డబుల్ తడ్కా దాల్",
        "ingredients_te": [
          [
            "కందిపప్పు",
            "1 cup boiled with turmeric"
          ],
          [
            "వెల్లుల్లి",
            "8 cloves"
          ],
          [
            "ఉల్లిపాయ",
            "1 each chopped"
          ],
          [
            "నెయ్యి",
            "2.5 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tsp & 1/4 tsp"
          ],
          [
            "ఎండుమిర్చి",
            "2 pcs & 1 tsp"
          ],
          [
            "కసూరీ మేథీ",
            "1 tsp & handful"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "పప్పును ఉడికించండి|నెయ్యిలో జీలకర్ర, వెల్లుల్లి, ఇంగువ వేయించి కలపండి|మరోసారి ఎండుమిర్చి తడ్కా వేయండి"
      },
      {
        "name_te": "ఆలూ గోబీ డ్రై సబ్జీ",
        "ingredients_te": [
          [
            "బంగాళాదుంప",
            "1.5 cups each cubed & florets"
          ],
          [
            "అల్లం",
            "1 tbsp"
          ],
          [
            "పసుపు",
            "1/2 tsp, 1 tsp & 1/2 tsp"
          ],
          [
            "జీలకర్ర",
            "1 tsp"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "ఆలూ, కాలీఫ్లవర్ ముక్కలను నూనెలో మసాలాలతో మూతపెట్టి మగ్గించండి"
      },
      {
        "name_te": "సువాసనగల జీరా రైస్",
        "ingredients_te": [
          [
            "బాస్మతి బియ్యం",
            "1.5 cups"
          ],
          [
            "జీలకర్ర",
            "1.5 tbsp"
          ],
          [
            "నెయ్యి",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "నెయ్యిలో జీలకర్ర, సుగంధ ద్రవ్యాలు వేయించి బాస్మతి అన్నంతో కలపండి"
      }
    ]
  },
  "19": {
    "meal_te": "పంజాబీ రాజ్మా చావల్ + కచుంబర్ సలాడ్",
    "desc_te": "ఉత్తర భారత శైలి రాజ్మా మసాలా గ్రేవీ, సువాసనగల బాస్మతి అన్నం మరియు తాజా కచుంబర్ సలాడ్.",
    "state_te": "పంజాబ్",
    "cuisine_te": "పంజాబీ సాంప్రదాయం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "పంజాబీ రాజ్మా మసాలా",
        "ingredients_te": [
          [
            "బీన్స్",
            "1.5 cups"
          ],
          [
            "ఉల్లిపాయ",
            "2 large"
          ],
          [
            "టమోటా",
            "2 cups"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1.5 tbsp"
          ],
          [
            "గరం మసాలా",
            "1.5 tbsp"
          ],
          [
            "ధనియాల పొడి",
            "1 tbsp each"
          ],
          [
            "నెయ్యి",
            "2 tbsp"
          ],
          [
            "కసూరీ మేథీ",
            "1 tsp"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "నానబెట్టిన రాజ్మాను ఉడికించండి|ఉల్లి, అల్లం, వెల్లుల్లి, టమోటా గ్రేవీలో రాజ్మా మరిగించండి"
      },
      {
        "name_te": "బాస్మతి అన్నం & సలాడ్",
        "ingredients_te": [
          [
            "బాస్మతి బియ్యం",
            "1.5 cups"
          ],
          [
            "ఉల్లిపాయ",
            "1 cup"
          ],
          [
            "నిమ్మకాయ",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_te": "బాస్మతి అన్నం మరియు తాజా కచుంబర్ సలాడ్"
      }
    ]
  },
  "20": {
    "meal_te": "ఆంధ్ర ఘాటైన చికెన్ కూర + వేడి అన్నం",
    "desc_te": "గుంటూరు ఎండుమిర్చి ఘాటుతో కూడిన ఆంధ్ర చికెన్ కర్రీ మరియు నెయ్యితో కూడిన వేడి అన్నం.",
    "state_te": "ఆంధ్రప్రదేశ్",
    "cuisine_te": "ఆంధ్ర ఘాటైన వంటకాలు",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "గుంటూరు చికెన్ కూర",
        "ingredients_te": [
          [
            "చికెన్",
            "600g"
          ],
          [
            "ఉల్లిపాయ",
            "2 large"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "2 tbsp"
          ],
          [
            "కారం పొడి",
            "2 tbsp"
          ],
          [
            "జీలకర్ర",
            "1.5 tbsp & 1 tsp ground"
          ],
          [
            "కొబ్బరి",
            "1 tbsp each ground to paste"
          ],
          [
            "గరం మసాలా",
            "1 tsp"
          ],
          [
            "కరివేపాకు",
            "3 sprigs"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "చికెన్‌ను ఉల్లిపాయలు, అల్లం వెల్లుల్లితో వేయించండి|గుంటూరు కారం, గరం మసాలా వేసి ఉడికించండి"
      },
      {
        "name_te": "వేడి అన్నం & నెయ్యి",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "స్వచ్ఛమైన నెయ్యి",
            "1 tbsp"
          ]
        ],
        "quick_te": "వేడి అన్నంపై స్వచ్ఛమైన నెయ్యి వేసి సర్వ్ చేయండి"
      }
    ]
  },
  "21": {
    "meal_te": "మెత్తని చపాతీ + పనీర్ బటర్ మసాలా",
    "desc_te": "గోధుమ పిండితో చేసిన మెత్తని ఫుల్కాలు మరియు క్రీమీ రిచ్ పనీర్ బటర్ మసాలా.",
    "state_te": "ఉత్తర భారతదేశం",
    "cuisine_te": "ఉత్తర భారత ఇంటి వంట",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మెత్తని గోధుమ ఫుల్కా",
        "ingredients_te": [
          [
            "గోధుమ పిండి",
            "2 cups"
          ],
          [
            "నీరు",
            "3/4 cup"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "గోధుమ పిండితో గుండ్రంగా ఒత్తి మంటపై కాల్చండి"
      },
      {
        "name_te": "క్రీమీ పనీర్ బటర్ మసాలా",
        "ingredients_te": [
          [
            "పనీర్",
            "250g"
          ],
          [
            "టమోటా",
            "2 cups"
          ],
          [
            "ఉల్లిపాయ",
            "1 finely chopped"
          ],
          [
            "Cashew Paste",
            "10 cashews blended"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1 tbsp"
          ],
          [
            "వెన్న",
            "3 tbsp & 2 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "1.5 tsp"
          ],
          [
            "గరం మసాలా",
            "1/2 tsp & 1 tsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "టమోటా, కాజు గ్రేవీని వెన్నలో ఉడికించండి|పనీర్ ముక్కలు, క్రీమ్, కసూరీ మేథీ కలపండి"
      }
    ]
  },
  "22": {
    "meal_te": "బటర్ చికెన్ + గార్లిక్ బటర్ నాన్ + జీరా రైస్",
    "desc_te": "ముర్గ్ మఖానీ రిచ్ టమోటా బటర్ గ్రేవీ, బొగ్గుల పొయ్యి శైలి గార్లిక్ నాన్ మరియు జీరా రైస్.",
    "state_te": "ఢిల్లీ / పంజాబ్",
    "cuisine_te": "మొఘలాయి నార్త్ ఇండియన్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "రెస్టారెంట్ స్టైల్ బటర్ చికెన్",
        "ingredients_te": [
          [
            "చికెన్",
            "500g"
          ],
          [
            "పెరుగు",
            "1/2 cup"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "2 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "2 tbsp"
          ],
          [
            "టమోటా",
            "2 cups"
          ],
          [
            "Cashew Paste",
            "15 cashews blended"
          ],
          [
            "వెన్న",
            "4 tbsp"
          ],
          [
            "తాజా క్రీమ్",
            "3 tbsp"
          ],
          [
            "కసూరీ మేథీ",
            "1 tbsp"
          ],
          [
            "గరం మసాలా",
            "1 tsp each"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "రోస్ట్ చేసిన చికెన్‌ను క్రీమీ టమోటా బటర్ గ్రేవీలో ఉడికించండి|కసూరీ మేథీ చల్లండి"
      },
      {
        "name_te": "గార్లిక్ బటర్ నాన్",
        "ingredients_te": [
          [
            "మైదా",
            "2 cups"
          ],
          [
            "పెరుగు",
            "3 tbsp"
          ],
          [
            "Baking Powder & Soda",
            "1/2 tsp & 1/4 tsp"
          ],
          [
            "వెల్లుల్లి",
            "2 tbsp"
          ],
          [
            "వెన్న",
            "3 tbsp & 1 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "మైదా పిండిని ఒత్తి వెల్లుల్లి, కొత్తిమీర చల్లి పెనంపై కాల్చండి|వెన్న రాయండి"
      },
      {
        "name_te": "జీరా రైస్",
        "ingredients_te": [
          [
            "బాస్మతి బియ్యం",
            "1.5 cups"
          ],
          [
            "జీలకర్ర",
            "1.5 tbsp"
          ],
          [
            "నెయ్యి",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "నెయ్యి, జీలకర్రతో కలిపిన బాస్మతి అన్నం"
      }
    ]
  },
  "23": {
    "meal_te": "మలబార్ పరోటా + చికెన్ సాల్నా / వెజ్ కుర్మా",
    "desc_te": "పొరలు పొరలుగా ఉండే కరకరలాడే కేరళ పరోటా మరియు రోడ్డు పక్కన లభించే మధురై స్టైల్ చికెన్ సాల్నా.",
    "state_te": "తమిళనాడు / కేరళ",
    "cuisine_te": "స్ట్రీట్ టిఫిన్ స్పెషల్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "పొరల మలబార్ పరోటా",
        "ingredients_te": [
          [
            "మైదా",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1 tsp & 1/2 tsp"
          ],
          [
            "నూనె",
            "4 tbsp"
          ],
          [
            "నీరు",
            "3/4 cup"
          ]
        ],
        "quick_te": "మైదా పిండిని సాగదీసి పొరలుగా చుట్టండి|పెనంపై నెయ్యితో కాల్చి చేతులతో తట్టండి"
      },
      {
        "name_te": "మధురై చికెన్ సాల్నా",
        "ingredients_te": [
          [
            "చికెన్",
            "400g"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "1 cup & 2 chopped"
          ],
          [
            "కొబ్బరి",
            "1/2 cup, 6 pcs & 1 tbsp ground to fine paste"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1.5 tbsp"
          ],
          [
            "గరం మసాలా",
            "1 tbsp each"
          ],
          [
            "కొత్తిమీర",
            "handful"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "చికెన్, కొబ్బరి-గసగసాల పేస్ట్‌తో రోడ్డు పక్క శైలి సాల్నా గ్రేవీ మరిగించండి"
      }
    ]
  },
  "24": {
    "meal_te": "చీజ్ పిజ్జా (మార్ఘరిటా) + గార్లిక్ బ్రెడ్",
    "desc_te": "క్రిస్పీ క్రస్ట్, మోజారెల్లా చీజ్, ఒరేగానో బేసిల్‌తో నిండిన పిజ్జా మరియు వెల్లుల్లి బ్రెడ్.",
    "state_te": "ఇటలీ",
    "cuisine_te": "ఇటాలియన్ క్లాసిక్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మార్ఘరిటా చీజ్ పిజ్జా",
        "ingredients_te": [
          [
            "Pizza Dough / Pizza Base",
            "1 base"
          ],
          [
            "టమోటా",
            "1/2 cup"
          ],
          [
            "చీజ్",
            "1.5 cups"
          ],
          [
            "Fresh Basil & Oregano",
            "handful & 1 tsp"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "to taste"
          ]
        ],
        "quick_te": "పిజ్జా బేస్‌పై సాస్ రాయండి|మోజారెల్లా చీజ్, బాసిల్ వేసి ఓవెన్‌లో బేక్ చేయండి"
      },
      {
        "name_te": "క్రిస్పీ గార్లిక్ బ్రెడ్",
        "ingredients_te": [
          [
            "బ్రెడ్",
            "4 pcs"
          ],
          [
            "వెన్న",
            "2 tbsp"
          ],
          [
            "వెల్లుల్లి",
            "1 tbsp"
          ],
          [
            "Oregano & Parsley",
            "1/2 tsp each"
          ],
          [
            "ఉప్పు",
            "pinch"
          ]
        ],
        "quick_te": "బ్రెడ్‌పై వెల్లుల్లి వెన్న రాసి క్రిస్పీగా టోస్ట్ చేయండి"
      }
    ]
  },
  "25": {
    "meal_te": "వైట్ సాస్ పాస్తా (క్రీమీ ఆల్ఫ్రెడో) + గార్లిక్ టోస్ట్",
    "desc_te": "వెన్న, చీజ్, పాలతో తయారైన క్రీమీ వైట్ సాస్ పెన్నే పాస్తా మరియు క్రిస్పీ గార్లిక్ టోస్ట్.",
    "state_te": "ఇటలీ",
    "cuisine_te": "ఇటాలియన్ పాస్తా",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "వైట్ సాస్ పెన్నే పాస్తా",
        "ingredients_te": [
          [
            "పాస్తా",
            "200g boiled al dente"
          ],
          [
            "వెన్న",
            "2 tbsp"
          ],
          [
            "మైదా",
            "2 tbsp"
          ],
          [
            "పాలు",
            "2 cups"
          ],
          [
            "వెల్లుల్లి",
            "1 tbsp"
          ],
          [
            "క్యాప్సికమ్",
            "1/2 cup each sautéed"
          ],
          [
            "చీజ్",
            "1/2 cup grated"
          ],
          [
            "మిరియాలు",
            "1 tsp each"
          ],
          [
            "ఉప్పు",
            "to taste"
          ]
        ],
        "quick_te": "పాస్తా ఉడికించండి|వెన్న, మైదా, పాలు, చీజ్‌తో సాస్ చేసి పాస్తా కలపండి"
      }
    ]
  },
  "26": {
    "meal_te": "వెజ్ ఫ్రైడ్ రైస్ + గోబీ మంచూరియన్",
    "desc_te": "తీవ్రమైన మంటపై టాస్ చేసిన కూరగాయల చైనీస్ ఫ్రైడ్ రైస్ మరియు కరకరలాడే గోబీ మంచూరియన్.",
    "state_te": "ఇండో-చైనీస్",
    "cuisine_te": "ఇండో-చైనీస్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "వెజ్ ఫ్రైడ్ రైస్",
        "ingredients_te": [
          [
            "బియ్యం",
            "3 cups"
          ],
          [
            "వెల్లుల్లి",
            "2 tbsp"
          ],
          [
            "క్యారెట్",
            "1.5 cups finely chopped"
          ],
          [
            "ఉల్లిపాయ",
            "1/2 cup"
          ],
          [
            "సోయా సాస్",
            "1.5 tbsp"
          ],
          [
            "మిరియాలు",
            "1 tsp & 1/2 tsp"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "అధిక మంటపై కూరగాయలు టాస్ చేయండి|అన్నం, సోయా సాస్, మిరియాలు కలిపి టాస్ చేయండి"
      },
      {
        "name_te": "క్రిస్పీ గోబీ మంచూరియన్",
        "ingredients_te": [
          [
            "కాలీఫ్లవర్",
            "250g"
          ],
          [
            "మైదా",
            "3 tbsp each"
          ],
          [
            "అల్లం",
            "1 tbsp each"
          ],
          [
            "టమోటా",
            "1 tbsp each"
          ],
          [
            "ఉల్లిపాయ",
            "1/4 cup"
          ],
          [
            "నూనె",
            "for cooking"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "కాలీఫ్లవర్‌ను పిండిలో ముంచి వేయించండి|సాస్‌లు, వెల్లుల్లి, స్ప్రింగ్ ఆనియన్స్‌తో టాస్ చేయండి"
      }
    ]
  },
  "27": {
    "meal_te": "చిల్లీ చికెన్ + వెజ్ హక్కా నూడుల్స్",
    "desc_te": "ఇండో-చైనీస్ స్టైల్ బోన్‌లెస్ క్రిస్పీ చిల్లీ చికెన్ మరియు నూడుల్స్ కాంబో.",
    "state_te": "పశ్చిమ బెంగాల్",
    "cuisine_te": "ఇండో-చైనీస్ నాన్-వెజ్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "కోల్‌కతా చిల్లీ చికెన్",
        "ingredients_te": [
          [
            "చికెన్",
            "400g"
          ],
          [
            "గుడ్డు",
            "2 tbsp & 1 egg white"
          ],
          [
            "సోయా సాస్",
            "1.5 tbsp each"
          ],
          [
            "ఉల్లిపాయ",
            "1 cup each"
          ],
          [
            "అల్లం",
            "1.5 tbsp each"
          ],
          [
            "పచ్చిమిర్చి",
            "4 pcs"
          ],
          [
            "ఉల్లిపాయ",
            "1/2 cup"
          ],
          [
            "నూనె",
            "for cooking"
          ],
          [
            "ఉప్పు",
            "1/2 tsp each"
          ]
        ],
        "quick_te": "చికెన్ ముక్కలను వేయించండి|క్యాప్సికమ్, ఉల్లి, చిల్లీ సాస్‌తో టాస్ చేయండి"
      },
      {
        "name_te": "హక్కా నూడుల్స్",
        "ingredients_te": [
          [
            "నూడుల్స్",
            "200g boiled al dente"
          ],
          [
            "క్యారెట్",
            "1.5 cups"
          ],
          [
            "వెల్లుల్లి",
            "1 tbsp"
          ],
          [
            "సోయా సాస్",
            "1 tbsp each"
          ],
          [
            "నూనె",
            "1 tbsp & 1/2 tsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "నూడుల్స్ ఉడికించి కూరగాయలు, సాస్‌లతో టాస్ చేయండి"
      }
    ]
  },
  "28": {
    "meal_te": "ప్యాడ్ థాయ్ నూడుల్స్ (థాయ్ ఫ్రైడ్ నూడుల్స్) + పల్లీలు",
    "desc_te": "చింతపండు, సోయా సాస్, వేరుశనగపప్పు, స్ప్రింగ్ ఆనియన్స్‌తో థాయ్‌లాండ్ స్ట్రీట్ నూడుల్స్.",
    "state_te": "థాయిలాండ్",
    "cuisine_te": "థాయ్ స్ట్రీట్ ఫుడ్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "బ్యాంకాక్ ప్యాడ్ థాయ్",
        "ingredients_te": [
          [
            "బియ్యం",
            "200g"
          ],
          [
            "Firm Tofu (cubed)",
            "1/2 cup"
          ],
          [
            "చింతపండు",
            "2 tbsp each"
          ],
          [
            "సోయా సాస్",
            "2 tbsp"
          ],
          [
            "ఉల్లిపాయ",
            "1 cup & 1/2 cup"
          ],
          [
            "నిమ్మకాయ",
            "3 tbsp & wedges"
          ],
          [
            "నూనె",
            "2 tbsp"
          ]
        ],
        "quick_te": "రైస్ నూడుల్స్‌ను చింతపండు సాస్, కూరగాయలతో టాస్ చేయండి|పల్లీలు చల్లండి"
      }
    ]
  },
  "29": {
    "meal_te": "జపనీస్ రామెన్ నూడుల్ బౌల్ (గుడ్డుతో)",
    "desc_te": "సోయా బ్రాత్, పర్ఫెక్ట్ గా మరిగిన రామెన్ నూడుల్స్ మరియు మ్యారినేట్ చేసిన సాఫ్ట్ బాయిల్డ్ గుడ్డు.",
    "state_te": "జపాన్",
    "cuisine_te": "జపనీస్ రామెన్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "టోక్యో షోయు రామెన్",
        "ingredients_te": [
          [
            "నూడుల్స్",
            "200g"
          ],
          [
            "Vegetable Broth",
            "3 cups"
          ],
          [
            "నూనె",
            "3 tbsp & 1 tbsp"
          ],
          [
            "అల్లం",
            "1 tsp each"
          ],
          [
            "నూనె",
            "2 halves"
          ],
          [
            "Sweet Corn, Scallions, Nori Sheet",
            "for topping"
          ],
          [
            "ఉప్పు",
            "pinch"
          ]
        ],
        "quick_te": "సోయా బ్రాత్‌ను మరిగించండి|నూడుల్స్, సాఫ్ట్ బాయిల్డ్ ఎగ్, స్ప్రింగ్ ఆనియన్స్ అమర్చండి"
      }
    ]
  },
  "30": {
    "meal_te": "ఫలాఫెల్ పీటా పాకెట్ + క్రీమీ హమ్ముస్",
    "desc_te": "మధ్యప్రాచ్య శైలి కరకరలాడే చిక్‌పీ ఫలాఫెల్స్, పీటా బ్రెడ్ మరియు తాజా హమ్ముస్ డిప్.",
    "state_te": "లెబనాన్ / మధ్యప్రాచ్యం",
    "cuisine_te": "మధ్యప్రాచ్య వంటకాలు",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "క్రిస్పీ ఫలాఫెల్",
        "ingredients_te": [
          [
            "బఠాణీలు",
            "1.5 cups"
          ],
          [
            "Parsley, Coriander & Mint",
            "1 cup chopped"
          ],
          [
            "ఉల్లిపాయ",
            "4 cloves & 1 chopped"
          ],
          [
            "ధనియాల పొడి",
            "1 tsp each"
          ],
          [
            "Baking Powder",
            "1/2 tsp"
          ],
          [
            "నూనె",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "శనగలు, మూలికలు గ్రైండ్ చేయండి|చిన్న ప్యాటీలుగా చేసి నూనెలో వేయించండి"
      },
      {
        "name_te": "క్రీమీ హమ్ముస్ & పీటా",
        "ingredients_te": [
          [
            "నూనె",
            "1.5 cups"
          ],
          [
            "Tahini (Sesame Paste)",
            "1/3 cup"
          ],
          [
            "నిమ్మకాయ",
            "2 tbsp"
          ],
          [
            "వెల్లుల్లి",
            "1 clove"
          ],
          [
            "బ్రెడ్",
            "4 pcs"
          ],
          [
            "నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "ఉడికించిన శనగలు, తాహిని, ఆలివ్ ఆయిల్‌తో హమ్ముస్ చేసి పీటాతో సర్వ్ చేయండి"
      }
    ]
  },
  "31": {
    "meal_te": "ముంబై పావ్ భాజీ + బటర్ పావ్",
    "desc_te": "తవాపై వెన్నతో మాష్ చేసిన మసాలా కూరగాయల భాజీ మరియు వెన్నలో వేయించిన పావ్ బన్స్.",
    "state_te": "మహారాష్ట్ర",
    "cuisine_te": "ముంబై స్ట్రీట్ ఫుడ్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "ముంబై తవా పావ్ భాజీ",
        "ingredients_te": [
          [
            "నూనె",
            "3 cups mashed"
          ],
          [
            "ఉల్లిపాయ",
            "1 cup each finely chopped"
          ],
          [
            "టమోటా",
            "4 finely chopped"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "2 tbsp"
          ],
          [
            "Pav Bhaji Masala",
            "2.5 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "1.5 tbsp"
          ],
          [
            "వెన్న",
            "75g"
          ],
          [
            "నిమ్మకాయ",
            "2 tbsp & 1/2 cup"
          ],
          [
            "కసూరీ మేథీ",
            "1 tsp"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "కూరగాయలను ఉడికించి తవాపై వెన్న, పావ్ భాజీ మసాలాతో మెదపండి"
      },
      {
        "name_te": "బటర్ టోస్టెడ్ పావ్",
        "ingredients_te": [
          [
            "పావ్ బన్స్",
            "6 pcs"
          ],
          [
            "వెన్న",
            "3 tbsp"
          ],
          [
            "Pav Bhaji Masala & Coriander",
            "pinch for dusting"
          ]
        ],
        "quick_te": "పావ్ బన్స్‌ను వెన్నలో పెనంపై కాల్చండి"
      }
    ]
  },
  "32": {
    "meal_te": "ఛోలే భటూరే + పచ్చిమిర్చి ఊరగాయ",
    "desc_te": "పంజాబీ శైలి మసాలా కాబూలీ శనగల కూర మరియు వేడివేడిగా పొంగే భటూరా.",
    "state_te": "పంజాబ్ / ఢిల్లీ",
    "cuisine_te": "పంజాబీ స్ట్రీట్ ఫుడ్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "పొంగే పంజాబీ భటూరా",
        "ingredients_te": [
          [
            "మైదా",
            "2 cups"
          ],
          [
            "బొంబాయి రవ్వ",
            "2 tbsp"
          ],
          [
            "పెరుగు",
            "3 tbsp"
          ],
          [
            "Baking Powder & Soda",
            "1/2 tsp & 1/4 tsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp each"
          ],
          [
            "నూనె",
            "3 cups"
          ]
        ],
        "quick_te": "మైదా పిండిని నానబెట్టి పెద్ద పూరీలా ఒత్తండి|వేడి నూనెలో బంగారు రంగులో వేయించండి"
      },
      {
        "name_te": "అమృత్‌సరి ఛోలే",
        "ingredients_te": [
          [
            "బఠాణీలు",
            "1.5 cups"
          ],
          [
            "ఉల్లిపాయ",
            "2 chopped & 2 pureed"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1.5 tbsp"
          ],
          [
            "ధనియాల పొడి",
            "1.5 tbsp & 1 tbsp"
          ],
          [
            "Amchur (Dry Mango Powder)",
            "1 tsp"
          ],
          [
            "Tea Bag (for dark color)",
            "1 pc"
          ],
          [
            "నెయ్యి",
            "2 tbsp"
          ],
          [
            "కసూరీ మేథీ",
            "1 tsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "నల్ల టీ బ్యాగ్‌తో శనగలు ఉడికించండి|ఉల్లి, టమోటా, ఛోలే మసాలాతో ఉడికించండి"
      }
    ]
  },
  "33": {
    "meal_te": "మెక్సికన్ చీజ్ టాకోస్ + గ్వాకమోల్ + సల్సా",
    "desc_te": "క్రిస్పీ కార్న్ టాకో షెల్స్, బీన్స్, చీజ్, అవకాడో గ్వాకమోల్ మరియు తాజా టమోటా సల్సా.",
    "state_te": "మెక్సికో",
    "cuisine_te": "మెక్సికన్ సాంప్రదాయం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "చీజ్ టాకోస్",
        "ingredients_te": [
          [
            "Crispy Taco Shells / Tortillas",
            "6 pcs"
          ],
          [
            "బీన్స్",
            "1.5 cups seasoned with cumin & chilli"
          ],
          [
            "చీజ్",
            "1 cup"
          ],
          [
            "టమోటా",
            "1 cup"
          ],
          [
            "పెరుగు",
            "3 tbsp"
          ],
          [
            "Salsa",
            "1/2 cup"
          ]
        ],
        "quick_te": "టాకో షెల్స్‌లో బీన్స్, సల్సా, చీజ్ నింపండి"
      },
      {
        "name_te": "ఆవకాడో గ్వాకమోల్",
        "ingredients_te": [
          [
            "Ripe Avocados",
            "2 pcs"
          ],
          [
            "నిమ్మకాయ",
            "1 tbsp"
          ],
          [
            "ఉల్లిపాయ",
            "2 tbsp each"
          ],
          [
            "ఉప్పు",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_te": "ఆవకాడో మెదిపి ఉల్లి, టమోటా, నిమ్మరసం కలపండి"
      }
    ]
  },
  "34": {
    "meal_te": "కరకరలాడే ఉల్లిపాయ పకోడీ + వేడి మసాలా టీ",
    "desc_te": "వానకాలం సాయంత్రం తినే కరకరలాడే ఉల్లిపాయ పకోడీ మరియు యాలకులు, అల్లం వేసిన మసాలా ఛాయ్.",
    "state_te": "తమిళనాడు / దక్షిణ భారతదేశం",
    "cuisine_te": "సాయంత్రం టీ స్నాక్స్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "ఉల్లిపాయ పకోడీ",
        "ingredients_te": [
          [
            "ఉల్లిపాయ",
            "3 large"
          ],
          [
            "Besan (Gram Flour)",
            "1 cup"
          ],
          [
            "బియ్యం",
            "3 tbsp"
          ],
          [
            "Fennel Seeds (crushed)",
            "1 tsp"
          ],
          [
            "అల్లం",
            "finely chopped"
          ],
          [
            "ఇంగువ",
            "1 tsp & 1/4 tsp"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "నూనె",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "ఉల్లిపాయ ముక్కలకు శనగపిండి, మిర్చి, కరివేపాకు పట్టించండి|వేడి నూనెలో వేయించండి"
      },
      {
        "name_te": "మసాలా ఛాయ్",
        "ingredients_te": [
          [
            "నీరు",
            "1 cup & 1 cup"
          ],
          [
            "Strong Tea Dust / Leaves",
            "2 tsp"
          ],
          [
            "అల్లం",
            "1 inch"
          ],
          [
            "యాలకులు",
            "3 pods"
          ],
          [
            "చక్కెర",
            "2 tsp"
          ]
        ],
        "quick_te": "పాలు, నీరు, టీ పొడి, దంచిన అల్లం, యాలకులు మరిగించండి"
      }
    ]
  },
  "35": {
    "meal_te": "కన్యాకుమారి కొబ్బరి చేపల పులుసు + మట్టా అన్నం + చేపల వేపుడు",
    "desc_te": "కొబ్బరిపాలు, మసాలాలతో మట్టికుండలో చేసిన కన్యాకుమారి మీన్ కుజ్హంబు మరియు మట్టా అన్నం.",
    "state_te": "తమిళనాడు / కేరళ",
    "cuisine_te": "కన్యాకుమారి సీఫుడ్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "కన్యాకుమారి కొబ్బరి చేపల పులుసు",
        "ingredients_te": [
          [
            "చేపలు",
            "500g"
          ],
          [
            "జీలకర్ర",
            "1 cup & 1 tsp ground to smooth paste"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "12 & 6 cloves"
          ],
          [
            "టమోటాలు",
            "2 chopped"
          ],
          [
            "చింతపండు రసం",
            "3 tbsp"
          ],
          [
            "ధనియాల పొడి",
            "2 tbsp & 1.5 tbsp"
          ],
          [
            "మెంతులు",
            "1/2 tsp each"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "కరివేపాకు",
            "2 sprigs"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "కొబ్బరి-జీలకర్ర పేస్ట్‌తో చేపల పులుసు మట్టికుండలో మరిగించండి"
      },
      {
        "name_te": "నాగర్‌కోయిల్ చేపల ఫ్రై",
        "ingredients_te": [
          [
            "చేపలు",
            "300g"
          ],
          [
            "కారం పొడి",
            "1.5 tsp & 1/2 tsp"
          ],
          [
            "అల్లం",
            "1 tsp & 1 tbsp"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "చేప ముక్కలకు మసాలా పట్టించి తవాపై కాల్చండి"
      },
      {
        "name_te": "కేరళ మట్టా అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "నీరు",
            "5 cups"
          ]
        ],
        "quick_te": "కేరళ ఎర్ర మట్టా అన్నం ఉడికించండి"
      }
    ]
  },
  "36": {
    "meal_te": "కేరళ మీన్ పొల్లిచ్చతు (అరటి ఆకు చేప) + అన్నం",
    "desc_te": "అరటి ఆకులో మసాలాలు నింపి కాల్చిన సాంప్రదాయ కేరళ చేప మరియు వేడి అన్నం.",
    "state_te": "కేరళ",
    "cuisine_te": "కేరళ సీఫుడ్ క్లాసిక్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "అరటి ఆకులో చేపల రోస్ట్",
        "ingredients_te": [
          [
            "చేపలు",
            "2 whole/steaks"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "1.5 cups"
          ],
          [
            "అల్లం",
            "1.5 tbsp each"
          ],
          [
            "టమోటా",
            "2 medium"
          ],
          [
            "పచ్చిమిర్చి",
            "2 sprigs & 3 slit"
          ],
          [
            "పసుపు",
            "1.5 tsp, 1/2 tsp, 1 tsp"
          ],
          [
            "చింతపండు",
            "1 piece / 1 tbsp"
          ],
          [
            "Fresh Banana Leaves",
            "2 softened over fire"
          ],
          [
            "కొబ్బరి నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "చేపను వేయించి మసాలా గ్రేవీతో అరటి ఆకులో చుట్టండి|పెనంపై కాల్చండి"
      },
      {
        "name_te": "వేడి అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "నీరు",
            "3.5 cups"
          ]
        ],
        "quick_te": "ఆవిరిపై వండిన అన్నం"
      }
    ]
  },
  "37": {
    "meal_te": "కేరళ ఆప్పం + వెజిటబుల్ స్టూ",
    "desc_te": "లేస్ అంచులతో మెత్తని కేరళ పాలప్పం మరియు కొబ్బరిపాలు కూరగాయల స్టూ.",
    "state_te": "కేరళ",
    "cuisine_te": "కేరళ సాంప్రదాయం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మెత్తని పాలప్పం",
        "ingredients_te": [
          [
            "పచ్చి బియ్యం",
            "2 cups soaked"
          ],
          [
            "తురిమిన కొబ్బరి",
            "1 cup"
          ],
          [
            "వండిన అన్నం",
            "1/2 cup"
          ],
          [
            "Yeast / Fermentation agent",
            "1/2 tsp"
          ],
          [
            "ఉప్పు",
            "1 tbsp & 1 tsp"
          ]
        ],
        "quick_te": "బియ్యం, కొబ్బరి పిండిని ఆప్పం పెనంలో ఆవిరిపై ఉడికించండి"
      },
      {
        "name_te": "కొబ్బరిపాలు వెజ్ స్టూ",
        "ingredients_te": [
          [
            "బంగాళాదుంప",
            "2 cups diced"
          ],
          [
            "పాలు",
            "2 cups & 1 cup"
          ],
          [
            "ఉల్లిపాయ",
            "1 sliced, 1 tbsp minced, 3 slit"
          ],
          [
            "యాలకులు",
            "1 inch, 3 pods, 4 pcs"
          ],
          [
            "నూనె",
            "1.5 tbsp & 2 sprigs"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "కూరగాయలను పల్చటి కొబ్బరిపాలలో ఉడికించి చిక్కటి పాలు కలపండి"
      }
    ]
  },
  "38": {
    "meal_te": "కేరళ ఆప్పం + మలబార్ ఎగ్ రోస్ట్",
    "desc_te": "మెత్తని ఆప్పం మరియు ఉల్లిపాయ, టమోటా, మసాలాలతో ఘాటుగా వేయించిన మలబార్ గుడ్డు రోస్ట్.",
    "state_te": "కేరళ / తమిళనాడు",
    "cuisine_te": "కేరళ నాన్-వెజ్ బ్రేక్‌ఫాస్ట్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మెత్తని పాలప్పం",
        "ingredients_te": [
          [
            "Appam Batter",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1/2 tsp each"
          ]
        ],
        "quick_te": "బియ్యం, కొబ్బరి పిండిని ఆప్పం పెనంలో ఆవిరిపై ఉడికించండి"
      },
      {
        "name_te": "మలబార్ ఎగ్ రోస్ట్",
        "ingredients_te": [
          [
            "నూనె",
            "4 slit lengthwise"
          ],
          [
            "ఉల్లిపాయ",
            "2.5 cups"
          ],
          [
            "టమోటా",
            "2 large"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1.5 tbsp"
          ],
          [
            "Fennel Seeds (crushed)",
            "1 tsp"
          ],
          [
            "ధనియాల పొడి",
            "1.5 tbsp & 1 tbsp"
          ],
          [
            "మిరియాలు",
            "1/2 tsp & 1/2 tsp"
          ],
          [
            "నూనె",
            "2 sprigs & 2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "ఉల్లిపాయలు, టమోటాలు నూనెలో వేయించి ఉడికించిన గుడ్లు కలపండి"
      }
    ]
  },
  "39": {
    "meal_te": "పుట్టు + కడల కర్రీ + అప్పడం",
    "desc_te": "ఆవిరిపై ఉడికించిన బియ్యప్పిండి పుట్టు, మసాలా నల్ల శనగల కర్రీ మరియు కరకరలాడే అప్పడం.",
    "state_te": "కేరళ / తమిళనాడు",
    "cuisine_te": "కేరళ సాంప్రదాయం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "ఆవిరి బియ్యం పుట్టు",
        "ingredients_te": [
          [
            "బియ్యం",
            "2 cups"
          ],
          [
            "తురిమిన కొబ్బరి",
            "1 cup"
          ],
          [
            "ఉప్పు",
            "3/4 cup & 1/2 tsp"
          ]
        ],
        "quick_te": "పుట్టు పొడిని తడిపి కొబ్బరి తురుముతో పొరలుగా ఆవిరిపై ఉడికించండి"
      },
      {
        "name_te": "మలబార్ కడల కర్రీ",
        "ingredients_te": [
          [
            "బఠాణీలు",
            "1.5 cups"
          ],
          [
            "కొబ్బరి",
            "1 cup coconut, fennel, coriander roasted dark brown & ground to paste"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "finely chopped"
          ],
          [
            "టమోటా",
            "1 chopped"
          ],
          [
            "ఆవాలు",
            "for tempering"
          ],
          [
            "కొబ్బరి నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "నల్ల శనగలను ఉడికించి కొబ్బరి మసాలాతో మరిగించండి"
      }
    ]
  },
  "40": {
    "meal_te": "కేరళ అవియల్ + ఎర్ర అన్నం + మజ్జిగ చారు",
    "desc_te": "మిశ్రమ కూరగాయలు, కొబ్బరి, జీలకర్ర పేస్ట్‌తో తయారైన అవియల్, మజ్జిగ చారు మరియు అన్నం.",
    "state_te": "కేరళ / తమిళనాడు",
    "cuisine_te": "కేరళ సద్యా విందు",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "కేరళ సాంప్రదాయ అవియల్",
        "ingredients_te": [
          [
            "గుడ్డు",
            "3 cups cut into 2-inch batons"
          ],
          [
            "జీలకర్ర",
            "1.5 cups & 1 tsp coarsely ground"
          ],
          [
            "పచ్చిమిర్చి",
            "4 slit"
          ],
          [
            "పెరుగు",
            "1/3 cup"
          ],
          [
            "నూనె",
            "2 tbsp & 3 sprigs"
          ],
          [
            "పసుపు",
            "1/2 tsp"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "కూరగాయలను ఉడికించి కొబ్బరి, పచ్చిమిర్చి, జీలకర్ర పేస్ట్, పెరుగు, కొబ్బరినూనె కలపండి"
      },
      {
        "name_te": "కేరళ మజ్జిగ చారు",
        "ingredients_te": [
          [
            "వెన్న",
            "2 cups"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "minced"
          ],
          [
            "మెంతులు",
            "for tadka"
          ],
          [
            "కొబ్బరి నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1/4 tsp & 1/2 tsp"
          ]
        ],
        "quick_te": "మజ్జిగలో పసుపు, కొబ్బరి పేస్ట్ వేసి తక్కువ మంటపై వేడిచేసి పోపు పెట్టండి"
      },
      {
        "name_te": "వేడి అన్నం",
        "ingredients_te": [
          [
            "బియ్యం",
            "1.5 cups"
          ],
          [
            "నీరు",
            "3.5 cups"
          ]
        ],
        "quick_te": "ఆవిరిపై వండిన అన్నం"
      }
    ]
  },
  "41": {
    "meal_te": "పనీర్ భూర్జీ + గోధుమ ఫుల్కా",
    "desc_te": "తురిమిన పనీర్, ఉల్లిపాయలు, టమోటాలు, కొత్తిమీరతో తయారైన హై ప్రోటీన్ భూర్జీ మరియు ఫుల్కాలు.",
    "state_te": "ఉత్తర భారతదేశం",
    "cuisine_te": "హై ప్రోటీన్ డిన్నర్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "మసాలా పనీర్ భూర్జీ",
        "ingredients_te": [
          [
            "పనీర్",
            "300g"
          ],
          [
            "ఉల్లిపాయ",
            "2 medium"
          ],
          [
            "టమోటా",
            "2 & 1/2 cup chopped"
          ],
          [
            "అల్లం",
            "2 minced & 1 tbsp minced"
          ],
          [
            "పసుపు",
            "1/2 tsp, 1 tsp, 1/2 tsp"
          ],
          [
            "నెయ్యి",
            "2 tbsp"
          ],
          [
            "Fresh Coriander",
            "handful"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "ఉల్లి, టమోటా, పచ్చిమిర్చి వేయించి తురిమిన పనీర్, కొత్తిమీర కలపండి"
      },
      {
        "name_te": "మెత్తని ఫుల్కా రోటీ",
        "ingredients_te": [
          [
            "గోధుమ పిండి",
            "2 cups"
          ],
          [
            "నీరు",
            "3/4 cup"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "గోధుమ పిండితో మెత్తని ఫుల్కాలు చేయండి"
      }
    ]
  },
  "42": {
    "meal_te": "శనగల గుడాలు (సుండల్) + యాలకుల మసాలా టీ",
    "desc_te": "పోపు గింజలు, పచ్చిమిర్చి, తురిమిన కొబ్బరితో తయారైన నల్ల శనగల సుండల్ మరియు అల్లం టీ.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "ఆలయ ప్రసాదం & స్నాక్స్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "నల్ల శనగల సుండల్",
        "ingredients_te": [
          [
            "నూనె",
            "2 cups"
          ],
          [
            "తురిమిన కొబ్బరి",
            "1/2 cup"
          ],
          [
            "మినప్పప్పు",
            "1 tsp & 1 tsp"
          ],
          [
            "పచ్చిమిర్చి",
            "2 pcs & 1 slit"
          ],
          [
            "అల్లం",
            "1/4 tsp & 1 tsp minced"
          ],
          [
            "కరివేపాకు",
            "2 sprigs"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "శనగలు ఉడికించి ఆవాలు, కరివేపాకు, మిర్చి, కొబ్బరి తురుముతో పోపు పెట్టండి"
      },
      {
        "name_te": "మసాలా ఛాయ్",
        "ingredients_te": [
          [
            "నీరు",
            "1 cup each"
          ],
          [
            "Tea Powder",
            "2 tsp"
          ],
          [
            "అల్లం",
            "crushed"
          ],
          [
            "చక్కెర",
            "2 tsp"
          ]
        ],
        "quick_te": "పాలు, నీరు, టీ పొడి, దంచిన అల్లం, యాలకులు మరిగించండి"
      }
    ]
  },
  "43": {
    "meal_te": "ఉడికించిన గుడ్డు మిరియాల మసాలా + చపాతీ",
    "desc_te": "చెట్టినాడు మిరియాల మసాలాతో వేయించిన గుడ్డు రోస్ట్ మరియు మెత్తని గోధుమ చపాతీలు.",
    "state_te": "తమిళనాడు / దక్షిణ భారతదేశం",
    "cuisine_te": "మిలిటరీ మెస్ స్పెషల్",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "చెట్టినాడ్ ఎగ్ పెప్పర్ ఫ్రై",
        "ingredients_te": [
          [
            "నూనె",
            "4 halved"
          ],
          [
            "ఉల్లిపాయ",
            "1 cup finely chopped"
          ],
          [
            "మిరియాలు",
            "1.5 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tsp each"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1 tbsp"
          ],
          [
            "కరివేపాకు",
            "2 sprigs"
          ],
          [
            "నువ్వుల నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1/4 tsp & 1 tsp"
          ]
        ],
        "quick_te": "ఉడికించిన గుడ్లను గాట్లు పెట్టి మిరియాల మసాలాతో రోస్ట్ చేయండి"
      },
      {
        "name_te": "మెత్తని గోధుమ చపాతీ",
        "ingredients_te": [
          [
            "గోధుమ పిండి",
            "2 cups"
          ],
          [
            "నీరు",
            "3/4 cup"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1/2 tsp"
          ]
        ],
        "quick_te": "గోధుమ పిండితో చేసిన మెత్తని చపాతీలు"
      }
    ]
  },
  "44": {
    "meal_te": "కొర్రల పొంగల్ + తోటకూర పప్పు కూటు",
    "desc_te": "ఆరోగ్యకరమైన చిరుధాన్యాల నెయ్యి పొంగల్ మరియు పచ్చని తోటకూర పప్పు కూటు.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "చిరుధాన్యాల ఆరోగ్య భోజనం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "కొర్రల నెయ్యి పొంగల్",
        "ingredients_te": [
          [
            "కొర్రలు (చిరుధాన్యాలు)",
            "1 cup"
          ],
          [
            "పెసరపప్పు",
            "1/2 cup"
          ],
          [
            "స్వచ్ఛమైన నెయ్యి",
            "3 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tbsp each"
          ],
          [
            "అల్లం",
            "1 tbsp & 10 pcs"
          ],
          [
            "ఇంగువ",
            "1 sprig & 1/4 tsp"
          ],
          [
            "నీరు",
            "4.5 cups"
          ],
          [
            "ఉప్పు",
            "1.5 tsp"
          ]
        ],
        "quick_te": "కొర్రలు, పెసరపప్పు మెత్తగా ఉడికించి నేతి పోపు కలపండి"
      },
      {
        "name_te": "తోటకూర పప్పు కూటు",
        "ingredients_te": [
          [
            "పాలకూర",
            "2 cups chopped"
          ],
          [
            "కందిపప్పు",
            "1/2 cup boiled"
          ],
          [
            "జీలకర్ర",
            "1/3 cup coconut & 1 tsp cumin ground"
          ],
          [
            "ఎండుమిర్చి",
            "1 tsp & 1 pc"
          ],
          [
            "నూనె",
            "1 tbsp"
          ],
          [
            "ఉప్పు",
            "1/4 tsp & 1 tsp"
          ]
        ],
        "quick_te": "తోటకూర, పప్పు ఉడికించి కొబ్బరి పేస్ట్, పోపు కలపండి"
      }
    ]
  },
  "45": {
    "meal_te": "వెజిటబుల్ ఓట్స్ ఉప్మా + కొబ్బరి చట్నీ",
    "desc_te": "క్యారెట్, బీన్స్, బఠాణీలతో తయారైన పీచు పదార్థాలు నిండిన ఓట్స్ ఉప్మా మరియు చట్నీ.",
    "state_te": "ఆరోగ్యకర సాంప్రదాయ ఆహారం",
    "cuisine_te": "పీచు పదార్థాలు నిండిన అల్పాహారం",
    "difficulty_te": "సులభం",
    "dishes_te": [
      {
        "name_te": "వెజిటబుల్ ఓట్స్ ఉప్మా",
        "ingredients_te": [
          [
            "ఓట్స్",
            "1.5 cups"
          ],
          [
            "క్యారెట్",
            "1 cup finely diced"
          ],
          [
            "ఉల్లిపాయ",
            "1 chopped, 1 tsp minced, 2 slit"
          ],
          [
            "మినప్పప్పు",
            "1 tsp & 1 tsp"
          ],
          [
            "జీడిపప్పు",
            "8 pcs"
          ],
          [
            "నూనె",
            "1.5 tbsp"
          ],
          [
            "కరివేపాకు",
            "for garnish"
          ],
          [
            "నీరు",
            "2 cups"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "కూరగాయలు ఉడికించి రోల్డ్ ఓట్స్, నీరు పోసి ఉడికించండి"
      },
      {
        "name_te": "తాజా కొబ్బరి చట్నీ",
        "ingredients_te": [
          [
            "తురిమిన కొబ్బరి",
            "1 cup"
          ],
          [
            "పుట్నాల పప్పు",
            "2 tbsp"
          ],
          [
            "Green Chilli",
            "2"
          ],
          [
            "ఉప్పు",
            "for taste"
          ]
        ],
        "quick_te": "కొబ్బరి, పుట్నాలు, మిర్చి, అల్లం వేసి రుబ్బండి|ఆవాలు, కరివేపాకు పోపు పెట్టండి"
      }
    ]
  },
  "46": {
    "meal_te": "మధురై కర్రీ దోశ (మటన్ కీమా దోశ)",
    "desc_te": "దోశపై గుడ్డు, ఘాటైన మటన్ కీమా సుక్కా మసాలా పొరలుగా వేసి కాల్చిన ప్రసిద్ధ మధురై కర్రీ దోశ.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "మధురై స్ట్రీట్ స్పెషల్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "మధురై మటన్ కీమా సుక్కా",
        "ingredients_te": [
          [
            "మటన్",
            "250g"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "1 cup chopped"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1 tbsp"
          ],
          [
            "Fennel Seeds (Sombu)",
            "1 tsp"
          ],
          [
            "మిరియాలు",
            "1.5 tsp"
          ],
          [
            "కారం పొడి",
            "1 tsp each"
          ],
          [
            "కరివేపాకు",
            "2 sprigs"
          ],
          [
            "నువ్వుల నూనె",
            "2 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp"
          ]
        ],
        "quick_te": "మటన్ కీమాను అల్లం, వెల్లుల్లి, సుగంధ ద్రవ్యాలతో డ్రైగా రోస్ట్ చేయండి"
      },
      {
        "name_te": "ఎగ్ & కీమా కర్రీ దోశ",
        "ingredients_te": [
          [
            "Dosa Batter (Idli/Dosa Maavu)",
            "2 cups"
          ],
          [
            "గుడ్డు",
            "3 beaten"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "మిరియాలు",
            "for garnish"
          ]
        ],
        "quick_te": "పెనంపై మందపాటి దోశ వేసి గుడ్డు, మటన్ కీమా పొరలుగా వేసి రెండు వైపులా కాల్చండి"
      }
    ]
  },
  "47": {
    "meal_te": "చెట్టినాడ్ చికెన్ సుక్కా (కారైకుడి చికెన్ చుక్కా)",
    "desc_te": "తాజాగా వేయించి దంచిన సుగంధ ద్రవ్యాల ఘాటుతో నూనెలో రోస్ట్ చేసిన చెట్టినాడ్ చికెన్ సుక్కా.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "చెట్టినాడు నాన్-వెజ్",
    "difficulty_te": "మధ్యస్థం",
    "dishes_te": [
      {
        "name_te": "చెట్టినాడ్ రోస్టెడ్ మసాలా",
        "ingredients_te": [
          [
            "Coriander Seeds",
            "1.5 tbsp"
          ],
          [
            "మిరియాలు",
            "1.5 tbsp"
          ],
          [
            "జీలకర్ర",
            "1 tsp each"
          ],
          [
            "ఎండుమిర్చి",
            "5 pcs"
          ],
          [
            "Kalpasi (Stone Flower)",
            "1 small piece"
          ],
          [
            "లవంగాలు",
            "1 inch & 3 cloves"
          ]
        ],
        "quick_te": "ధనియాలు, మిరియాలు, సోంపు, దాల్చినచెక్క వేయించి పొడి చేయండి"
      },
      {
        "name_te": "చెట్టినాడ్ చికెన్ సుక్కా",
        "ingredients_te": [
          [
            "చికెన్",
            "500g"
          ],
          [
            "చిన్న ఉల్లిపాయలు",
            "20 chopped"
          ],
          [
            "అల్లం వెల్లుల్లి పేస్ట్",
            "1.5 tbsp"
          ],
          [
            "టమోటాలు",
            "1 small chopped"
          ],
          [
            "కరివేపాకు",
            "3 sprigs"
          ],
          [
            "నూనె",
            "3 tbsp"
          ],
          [
            "ఉప్పు",
            "1 tsp & 1/2 tsp"
          ]
        ],
        "quick_te": "చికెన్‌ను తాజా చెట్టినాడ్ మసాలా, ఉల్లిపాయలతో నూనెలో రోస్ట్ చేయండి"
      }
    ]
  },
  "48": {
    "meal_te": "తిరునెల్వేలి గోధుమ హల్వా (సాంప్రదాయ నెయ్యి హల్వా)",
    "desc_te": "సాంప్రదాయ సంబా గోధుమ పాలు, తామ్రభరణి నీరు, స్వచ్ఛమైన నెయ్యితో వేడిగా నోట్లో కరిగిపోయే నెయ్యి హల్వా.",
    "state_te": "తమిళనాడు",
    "cuisine_te": "తిరునెల్వేలి సాంప్రదాయం",
    "difficulty_te": "కఠినం",
    "dishes_te": [
      {
        "name_te": "సంబా గోధుమ పాలు",
        "ingredients_te": [
          [
            "Whole Samba Wheat Berries (Godhumai)",
            "1 cup"
          ],
          [
            "నీరు",
            "4 cups for extraction"
          ]
        ],
        "quick_te": "గోధుమలను నానబెట్టి రుబ్బి తెల్లటి పాలు పిండండి"
      },
      {
        "name_te": "స్వచ్ఛమైన నెయ్యి తిరునెల్వేలి హల్వా",
        "ingredients_te": [
          [
            "పాలు",
            "1 cup"
          ],
          [
            "చక్కెర",
            "2 cups"
          ],
          [
            "నెయ్యి",
            "1 cup"
          ],
          [
            "జీడిపప్పు",
            "15-20 pcs roasted in ghee"
          ],
          [
            "యాలకులు",
            "1/2 tsp"
          ],
          [
            "చక్కెర",
            "2 tbsp sugar + 1 tbsp water"
          ]
        ],
        "quick_te": "గోధుమ పాలు, పంచదార సిరప్ మరిగించి స్వచ్ఛమైన నెయ్యి పోస్తూ దగ్గరపడేవరకు కలపండి"
      }
    ]
  }
};
